import AccordionPagination from '../utils/Pagination/AccordionPagination';
import { StreamApiProgramsWrapper } from './StreamApiPrograms.styled';

function StreamApiPrograms() {

const data = [
   { 
      header: '1. Given an integer array, move all zeros at the end.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '    Integer[] input = {2,0,7,1,8,0,2,0,5,3,0};\n'+
      '    List <Integer> output = Arrays.asList(input)\n'+
      '      .stream()\n'+
      '      .collect(Collectors.partitioningBy(n -> n == 0)) //partition based on our predicate\n'+
      '      .values() //values of map\n'+
      '      .stream()\n'+
      '      .flatMap(x -> x.stream())\n'+
      '      .collect(Collectors.toList());\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '2. Given a list of strings, print a map of string & no. of duplicate characters in a string.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      'import java.util.function.Function;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '    List <String> input = Arrays.asList("cat", "rabbit", "roosteer", "hippopotamus", "pronghorn");\n'+
      '\n'+
      '    Map <String, Long> output = input.stream()\n'+
      '      .collect(Collectors.toMap(\n'+
      '        Function.identity(), //Always return its input argument\n'+
      '        a -> a.chars() //Integer form\n'+
      '        .mapToObj(c -> (char) c) //Character obj\n'+
      '        .collect(Collectors.groupingBy(s -> s, Collectors.counting())) //Gives map of character to count\n'+
      '        .values()\n'+
      '        .stream()\n'+
      '        .filter(e -> e > 1) //Filter duplicates\n'+
      '        .count()\n'+
      '      ));\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '3. Find duplicates in an array.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '    int[] input = {1,1,2,3,4,5,6,5,7,8,8,1};\n'+
      '\n'+
      '    Set <String> output = new HashSet < > ();\n'+
      '    List <Integer> list = Arrays.stream(input).boxed().collect(Collectors.toList()); //boxed to convert int to Integer\n'+
      '\n'+
      '    list.stream()\n'+
      '      .filter(i -> Collections.frequency(list, i) > 1) //filter duplicates based on frequency\n'+
      '      .forEach(i -> output.add("Element " + i + " found " + Collections.frequency(list, i) + " times")); // Add duplicates to a set\n'+
      '\n'+
      '    for (String s: output) {\n'+
      '      System.out.println(s);\n'+
      '    }\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '4. Create stream of random numbers.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.*;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    Random random = new Random(); //create object\n'+
      '    Stream.generate(random::nextInt) //to generate next random integer\n'+
      '      .limit(5) //limit no. of values\n'+
      '      .forEach(System.out::println);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '5. Find the count of names by its length.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <String> names = Arrays.asList("John", "Alice", "Bob", "Jane");\n'+
      '    Map <Integer, Long> output = names.stream()\n'+
      '      .collect(Collectors.groupingBy(String::length, Collectors.counting())); //get count based on length\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '6. Find duplicate characters in a string.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    String input = "information";\n'+
      '\n'+
      '    List <Character> output = input.chars() //Get Integer values\n'+
      '      .mapToObj(c -> (char) c) //Map to character object\n'+
      '      .collect(Collectors.groupingBy(s -> s, Collectors.counting())) //find count\n'+
      '      .entrySet() //to iterate on map\n'+
      '      .stream()\n'+
      '      .filter(e -> e.getValue() > 1) //filter based on predicate\n'+
      '      .map(Map.Entry::getKey) //fetch keys\n'+
      '      .collect(Collectors.toList());\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '7. Remove null values from a list of string.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <String> input = Arrays.asList("apple", null, "banana", null, "orange");\n'+
      '    List <String> output = input.stream()\n'+
      '      .filter(Objects::nonNull) //filter based on our predicate\n'+
      '      .collect(Collectors.toList());\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '8. Find longest string in list of strings.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <String> input = Arrays.asList("apple", "banana", "cherry", "date", "grapefruit");\n'+
      '    Optional <String> output = input.stream()\n'+
      '      .max(Comparator.comparingInt(String::length)); //comparing string length to find max\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '9. Calculate average age of list of Person objects.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Person {\n'+
      '  String name;\n'+
      '  int age;\n'+
      '\n'+
      '  Person(String name, int age) {\n'+
      '    this.name = name;\n'+
      '    this.age = age;\n'+
      '  }\n'+
      '\n'+
      '  int getAge() {\n'+
      '    return this.age;\n'+
      '  }\n'+
      '}\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <Person> input = Arrays.asList(\n'+
      '      new Person("Alice", 25),\n'+
      '      new Person("Bob", 30),\n'+
      '      new Person("Charlie", 35)\n'+
      '    );\n'+
      '    double output = input.stream()\n'+
      '      .mapToInt(Person::getAge) //fetch age of person\n'+
      '      .average() //calculate average\n'+
      '      .orElse(0); //to return alternate value in case\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '10. Merge two sorted lists into a single sorted list.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      'import java.util.stream.*;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <Integer> input1 = Arrays.asList(1, 3, 5, 7, 9);\n'+
      '    List <Integer> input2 = Arrays.asList(2, 4, 6, 8, 10);\n'+
      '\n'+
      '    List <Integer> output = Stream.concat(input1.stream(), input2.stream())\n'+
      '      .sorted()\n'+
      '      .collect(Collectors.toList());\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '11. Find intersection of two lists.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <Integer> input1 = Arrays.asList(1, 2, 3, 4, 5);\n'+
      '    List <Integer> input2 = Arrays.asList(3, 4, 5, 6, 7);\n'+
      '\n'+
      '    List <Integer> output = input1.stream()\n'+
      '      .filter(input2::contains) //to filter common values\n'+
      '      .collect(Collectors.toList());\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '12. Remove duplicates from a list while preserving the order.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <Integer> input = Arrays.asList(1, 2, 3, 2, 4, 1, 5, 6, 5);\n'+
      '\n'+
      '    List <Integer> output = input.stream()\n'+
      '      .distinct() // to get distinct values\n'+
      '      .collect(Collectors.toList());\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '13. Given a list of transactions, find sum of transaction amounts for each day.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Transaction {\n'+
      '  String date;\n'+
      '  int amount;\n'+
      '\n'+
      '  Transaction(String date, int amount) {\n'+
      '    this.date = date;\n'+
      '    this.amount = amount;\n'+
      '  }\n'+
      '\n'+
      '  String getDate() {\n'+
      '    return this.date;\n'+
      '  }\n'+
      '\n'+
      '  int getAmount() {\n'+
      '    return this.amount;\n'+
      '  }\n'+
      '}\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <Transaction> input = Arrays.asList(\n'+
      '      new Transaction("2022-01-01", 100),\n'+
      '      new Transaction("2022-01-01", 200),\n'+
      '      new Transaction("2022-01-02", 300),\n'+
      '      new Transaction("2022-01-02", 400),\n'+
      '      new Transaction("2022-01-03", 500)\n'+
      '    );\n'+
      '    Map <String, Integer> output = input.stream()\n'+
      '      .collect(\n'+
      '        Collectors.groupingBy(\n'+
      '          Transaction::getDate,\n'+
      '          Collectors.summingInt(Transaction::getAmount)\n'+
      '        )\n'+
      '      );\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '14. Find the Kth smallest element in an array.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    int k = 3;\n'+
      '    int[] input = { 4 , 2 , 7 , 1 , 5 , 3 , 6 };\n'+
      '\n'+
      '    int output = Arrays.stream(input)\n'+
      '      .sorted() //sort values\n'+
      '      .skip(k - 1) //skip k-1 values\n'+
      '      .findFirst() //pick up first value in the list\n'+
      '      .orElse(-1); //an alternate value if k is out of invalid\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '15. Find frequency of each word.', 
      body:  
      'import java.util.function.Function;\n'+
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <String> input = Arrays.asList("apple", "banana", "apple", "cherry", "banana", "apple");\n'+
      '    Map <String, Long> output = input.stream()\n'+
      '      .collect(Collectors.groupingBy(\n'+
      '        Function.identity(),\n'+
      '        Collectors.counting()\n'+
      '      ));\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '16. Print even and odds in an array.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <Integer> input = Arrays.asList(1, 2, 3, 4, 5, 6);\n'+
      '    Map <Boolean, List <Integer>> output = input.stream()\n'+
      '      .collect(Collectors.partitioningBy(n -> n % 2 == 0)); //partition based on our predicate\n'+
      '\n'+
      '    List < Integer > evenL = output.get(true);\n'+
      '    List < Integer > oddL = output.get(false);\n'+
      '\n'+
      '    System.out.println(evenL);\n'+
      '    System.out.println(oddL);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '17. Find out all numbers starting with 1.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <Integer> input = Arrays.asList(10, 15, 8, 49, 25, 98, 32);\n'+
      '\n'+
      '    List <String> output = input.stream()\n'+
      '      .map(s -> s + "") // convert to string\n'+
      '      .filter(s -> s.startsWith("1")) // filter based on startsWith\n'+
      '      .collect(Collectors.toList());\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '18. Find max value present in an array.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <Integer> input = Arrays.asList(10, 15, 8, 49, 25, 98, 32, 15);\n'+
      '\n'+
      '    int output = input.stream()\n'+
      '      .max(Integer::compare) //Compare integers to get the maximum\n'+
      '      .get();\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '19. Find first non-repeated character in a string.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    String input = "Java articles are just awesome";\n'+
      '    Character output = input.chars()\n'+
      '      .mapToObj(c -> Character.toLowerCase(Character.valueOf((char) c)))\n'+
      '      .filter(c -> input.toLowerCase().indexOf(c) == input.toLowerCase().lastIndexOf(c))\n'+
      '      .findFirst()\n'+
      '      .orElse(null);\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '20. Group the strings that has same characters.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    String[] input = {\n'+
      '      "abcd",\n'+
      '      "java",\n'+
      '      "dcba",\n'+
      '      "ajav",\n'+
      '      "xyz",\n'+
      '      "epam",\n'+
      '      "pame",\n'+
      '      "aepm"\n'+
      '    };\n'+
      '    Collection <List <String>> output = Arrays.asList(input)\n'+
      '      .stream()\n'+
      '      .collect(Collectors.groupingBy(s -> {\n'+
      '        char[] c = s.toCharArray(); //get the characters\n'+
      '        Arrays.sort(c); //sort array to know if it forms the same string\n'+
      '        return new String(c);\n'+
      '      }))\n'+
      '      .values(); //values of map\n'+
      '    System.out.println(output);\n'+
      '  }\n'+
      '}'
   },
   { 
      header: '21. Find max salary employee from each department.', 
      body:  
      'import java.util.*;\n'+
      'import java.util.stream.Collectors;\n'+
      '\n'+
      'class Employee {\n'+
      '  String name;\n'+
      '  String dept;\n'+
      '  int salary;\n'+
      '\n'+
      '  Employee(String name, String dept, int salary) {\n'+
      '    this.name = name;\n'+
      '    this.dept = dept;\n'+
      '    this.salary = salary;\n'+
      '  }\n'+
      '\n'+
      '  String getDept() {\n'+
      '    return this.dept;\n'+
      '  }\n'+
      '\n'+
      '  int getSalary() {\n'+
      '    return this.salary;\n'+
      '  }\n'+
      '}\n'+
      '\n'+
      'class Main {\n'+
      '  public static void main(String[] args) {\n'+
      '\n'+
      '    List <Employee> input = Arrays.asList(\n'+
      '      new Employee("Ram", "HR", 25000),\n'+
      '      new Employee("Shiva", "IT", 50000),\n'+
      '      new Employee("Radha", "HR", 35000)\n'+
      '    );\n'+
      '    Map <String, Employee> output = input.stream()\n'+
      '      .collect(\n'+
      '        (Collectors.groupingBy(\n'+
      '          Employee::getDept,\n'+
      '          Collectors.collectingAndThen(\n'+
      '            Collectors.maxBy(\n'+
      '              Comparator.comparingInt(Employee::getSalary)\n'+
      '            ),\n'+
      '            Optional::get\n'+
      '          )\n'+
      '        )));\n'+
      '    for (String s: output.keySet()) {\n'+
      '      System.out.println(s + " -> " + output.get(s).name + " : " + output.get(s).salary);\n'+
      '    }\n'+
      '  }\n'+
      '}'
   }
 ];

return (
   <StreamApiProgramsWrapper>
      <header className="entry-header">
         <h1 className="entry-title" itemProp="headline">Stream API Interview Programs</h1>
      </header>
      <br/>
      <AccordionPagination accordionData={data} />
      <br/>
      </StreamApiProgramsWrapper>
)
};

export default StreamApiPrograms;